<template>
  <v-row class="white spa-tile">
    <v-item-group class="white advantage-tiles" active-class="grey lighten-5">
      <v-container>
        <v-row>
          <v-col v-for="tile in tiles" :key="tile.id" cols="12" md="4" class="pa-0">
            <v-item v-slot:default="{ active, toggle }" class="pa-3">
              <v-card flat class="mx-auto" min-height="300" @click="toggle" color="white">
                <div class="display-3 flex-grow-1 text-center">
                  <v-img
                    max-width="80"
                    :alt="tile.alt"
                    class="shrink ma-auto pt-5"
                    contain
                    :src="'/images/' + tile.image"
                    transition="scale-transition"
                  />
                </div>
                <v-card-title v-html="tile.html" class="adv-disclamer"></v-card-title>
              </v-card>
            </v-item>
          </v-col>
        </v-row>
      </v-container>
    </v-item-group>
  </v-row>
</template>

<script>
export default {
  name: "advblock",

  data: () => ({
    tiles: [
      {
        id: 0,
        image: "road.png",
        alt: "Собственные пути",
        html: "<strong>23,5</strong>&nbsp; км путей по ст. Доссор, &nbsp;<strong>7,3</strong> &nbsp; км по ст. Махамбет"
      },
      {
        id: 1,
        image: "cargo.png",
        alt: "Большая емкость путей",
        html: "Емкость свыше &nbsp;<strong>2200 условных вагонов</strong>"
      },
      {
        id: 2,
        image: "shield.png",
        alt: "Охрана территории",
        html: "Ответственное &nbsp;<strong> хранение</strong>&nbsp; – круглосуточная охрана"
      },
      {
        id: 3,
        image: "refresh.png",
        alt: "Быстрая подача-уборка",
        html:
          "<strong>Оперативная подача/уборка</strong>&nbsp; за счет использования собственной маневровой тяги, ускоренное включение в состав поездов по требованию клиента"
      },
      {
        id: 4,
        image: "constr.png",
        alt: "Ремонт",
        html:
          "Возможность &nbsp;<strong>организации ремонта</strong>&nbsp; вагонов по окончании отстоя на предприятиях-партнёрах в ближайшей доступности"
      },
      {
        id: 5,
        image: "types.png",
        alt: "Все виды вагонов",
        html:
          "Возможность &nbsp; <strong>подготовки цистерн и вагонов различных типов </strong> &nbsp; к перевозкам по окончании отстоя"
      }
    ]
  })
};
</script>

<style scoped>
.adv-disclamer {
  justify-content: center !important;
  text-align: center !important;
  font-weight: 300;
  word-break: break-word;
}

.advantage-tiles {
  width: 100% !important;
}
</style>
